export default __webpack_public_path__ + "static/media/Yuan 400 Interior (10).93de9a6a.jpg";